import React, { useState, useEffect } from "react";
import { Button, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { fetchSurvey } from "../../actions/survey";

import "./Survey.scss";
import { ReactSVG } from "react-svg";

const SurveyPage = () => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const [surveyResponses, setSurveyResponses] = useState([]);
	const { survey, status, loading } = useSelector((state) => state.fetchSurvey);

	useEffect(() => {
		dispatch(fetchSurvey(id));
	}, []);

	useEffect(() => {
		if (survey) {
			let result = [];
			const surveyData = survey.survey;
			surveyData.survey_responses.forEach((response) => {
				surveyData.survey_category.questions.forEach((question) => {
					if (response.question_id === question.id) {
						result.push({
							...question,
							answer_ids: response.answer_ids,
						});
					}
				});
			});
			setSurveyResponses(result);
		}
	}, [survey]);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div id="surveys-container">
				<div className="page-header">
					<h2 className="page-header-title">Survey Details</h2>
				</div>
				<div className="page-header-details-actions">
					<Link to="/surveys">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				{status === "SUCCEEDED" && (
					<div className="page-content">
						<div className="page-details-section">
							<div>
								<div className="box">
									<div className="box-header">
										<h2 className="box-title">Questions</h2>
									</div>
									<div className="box-content">
										{surveyResponses.length !== 0 &&
											surveyResponses.map((question, index) => (
												<div key={question.id} className="details-item">
													<div className="box-item-group">
														<div className="box-item-left">
															{`Question ${index + 1}. `}
															{question.name}
														</div>
														<div className="box-item-right">
															<ul>
																{question.answers.map((answer, answerIndex) => (
																	<li
																		key={answerIndex}
																		className={
																			question.answer_ids.includes(answer.id)
																				? "active"
																				: undefined
																		}
																	>
																		{`${answerIndex + 1}. `}
																		{answer.name}
																	</li>
																))}
															</ul>
														</div>
													</div>
												</div>
											))}
									</div>
								</div>
								<div className="box box-response">
									<div className="box-header">
										<h2 className="box-title">Products Recommended</h2>
									</div>
									<div className="box-content">
										<div className="details-item">
											<label>Score</label>
											<div className="text">
												{survey.response && survey.response.score}
											</div>
										</div>
										<div className="details-item">
											<label>Products</label>
											<div className="text">
												<ul className="products-list">
													<li>
														<div>
															<span>IDs:</span>{" "}
															{survey.response.productIds &&
																survey.response.productIds.join(", ")}
														</div>
														<div>
															<span>Description:</span>{" "}
															{survey.response.description &&
																survey.response.description}
														</div>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</Spin>
	);
};

export default SurveyPage;
